import { c as _c } from "react/compiler-runtime";
import { EventRead } from "@/TS/Interfaces/global_interfaces";
import { EventReadDate, EventReadTime } from "../read/header";
interface HeaderProps {
  event?: EventRead | null;
  title: string;
}
export const Header: React.FC<HeaderProps> = t0 => {
  const $ = _c(5);
  const {
    event,
    title
  } = t0;
  let t1;
  if ($[0] !== event || $[1] !== title) {
    t1 = event && <div className="flex flex-col"><div className="flex flex-col md:flex-row justify-between items-start"><div className="flex flex-col gap-2 mb-2 w-full md:w-1/2"><EventReadDate event={event} /><EventReadTime event={event} /></div><div className="flex w-full md:w-1/2 flex-col gap-2 mt-4 md:mt-0"><p className="font-bold">{title}</p><p>{event.agenda}</p></div></div></div>;
    $[0] = event;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex flex-col p-8 mb-4 rounded-lg bg-event bg-opacity-5">{t1}</div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};